import { useRouter } from 'next/router';

import type { SanityRichTextSection } from '#/lib/sanity/queries/richTextSection';
import { cn } from '#/lib/utils';

import { Headline } from './Headline';
import { RichText } from './RichText';

export function RichTextSection(props: SanityRichTextSection) {
  const { asPath } = useRouter();
  //TODO: Remove this once we move legal pages to their own page templates
  const isLegalPage = asPath.includes('/legal/');
  return (
    <div className="p-main mb-100">
      <div
        className={cn(
          'relative mx-auto mt-50 ',
          isLegalPage ? 'max-w-1000' : 'max-w-735',
        )}
      >
        {props.pageTitle ? (
          <Headline value={props.pageTitle} variant={2} className="mb-50" />
        ) : null}
        <RichText value={props.content} />
      </div>
    </div>
  );
}
